<template>
  <footer id="footer">
    <svg class="wave" id="wave-gray" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 461.04 30.48">
      <path class="cls-1" d="M460.9,872.42a7.38,7.38,0,0,1,
      0-.94,9.43,9.43,0,0,1,0-1.68,8.3,8.3,0,0,1,0-1.41,9,9,0,0,1,0-1.27,8.69,8.69,0,0,1,
      0-1.35,10.48,10.48,0,0,1,0-1.12,11.21,11.21,0,0,1,0-1.42,8.31,8.31,0,0,1,0-1.32c-.88,
      0-1.8-.07-2.81-.07H0a10.15,10.15,0,0,1,0,1.35,9.57,9.57,0,0,1-.07,2.33c0,.15,0,.3,0,
      .45a10,10,0,0,1,0,1.1,9.88,9.88,0,0,1,0,2.49,9.35,9.35,0,0,1-.05,2.18,10.27,10.27,0,0,
      1,0,1.84,10.39,10.39,0,0,1,0,2.23,11.22,11.22,0,0,1,0,1.64,10.52,10.52,0,0,1,0,2.57,
      9.63,9.63,0,0,1,0,1.86,9.53,9.53,0,0,1,0,1.85c0,.18,0,.37-.05.55a11,11,0,0,1,0,2.5c0,
      .31.07.62.08.93a94.09,94.09,0,0,0,27.66,4.61c20.78,0,32.25-9.6,55.45-9.6,16.5,0,29.68,
      9.6,45.12,9.6,15,0,30.93-9.6,47.53-9.6,15.93,0,32.44,9.6,49.2,9.6,15.79,0,31.8-7.2,
      47.77-7.2,14.26,0,28.49,7.2,42.49,7.2,16.93,0,33.52-9.6,49.44-9.6,18.18,0,35.47,9.6,
      51.37,9.6s27.86-6.71,41.73-8.91a12.83,12.83,0,0,0,3.16-1.73,9.74,9.74,0,0,1,0-2,6,6,0,
      0,1,0-.95,10.17,10.17,0,0,1,0-2.34,11.33,11.33,0,0,1,0-2.1A10.4,10.4,0,0,1,460.9,
      872.42Z" transform="translate(0.14 -861.84)"/>
    </svg>
    <div class="container">
      <img src="@/assets/logo.png" class="mx-auto d-block img-circle-larger logo-footer" alt="Logo">
      <div class="row">
        <div class="col-sm-12 col-md-6 order-md-2">
          <h3 class="mt-3 mb-3 text-left">Contato</h3>
          <form id="contactForm" class="needs-validation" novalidate>

            <div class="form-row">
              <div class="form-group col-6">
                <input type="text" id="contact-name" class="form-control" placeholder="Nome" required>
                <div class="invalid-feedback">
                  Informe o seu nome.
                </div>
              </div>
              <div class="form-group col-6">
                <input type="text" id="contact-phone" class="form-control sp_celphones" placeholder="Celular" required>
                <div class="invalid-feedback">
                  Informe o seu celular.
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group col-12">
                <input type="email" id="contact-mail" class="form-control" placeholder="Email" required>
                <div class="invalid-feedback">
                  Informe o seu email.
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group col-12">
                <textarea class="form-control" id="contact-message" rows="3" placeholder="Mensagem" required></textarea>
                <div class="invalid-feedback">
                  Informe a sua mensagem.
                </div>
              </div>
            </div>

            <div class="form-row form-check">
              <div class="form-group form-check col-12">
                <input type="checkbox" class="form-check-input" id="news">
                <label class="form-check-label" for="news">Quero receber novidades</label>
                <button type="submit" class="btn btn-login btn-footer">Enviar</button>
              </div>
            </div>

          </form>
        </div>

        <div class="col-6 col-sm-6 col-md-3 order-md-0">
          <h3 class="mt-3 mb-3 text-left">Minha Conta</h3>
          <ul class="styled">
            <li> <a :href="loginLink">Login</a> </li>
            <li> <a :href="registerLink">Cadastro</a> </li>
            <li> <a :href="resetPasswordLink">Esqueci minha senha</a> </li>
          </ul>
        </div>

        <div class="col-6 col-sm-6 col-md-3 order-md-1">
          <h3 class="mt-3 mb-3 text-left">Redes Sociais</h3>
          <div class="social">
            <ul class="list-unstyled">
              <li> <a href="https://www.instagram.com/manycontent"> <i class="fab fa-instagram"></i> instagram </a> </li>
              <li> <a href="https://www.facebook.com/manycontent"> <i class="fab fa-facebook"></i> facebook </a> </li>
              <li> <a href="https://twitter.com/manycontent"> <i class="fab fa-twitter"></i> twitter </a> </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['loginLink', 'registerLink', 'resetPasswordLink'])
  }
}
</script>
